import { combineReducers } from 'redux';
import loginReducer from '../features/LoginContainer/loginSlice';
import userReducer from '../features/v2/User/user-slice';
import pageSettingsReducer from '../features/PageSettings/page-settings-slice';
import companyReducer from '../features/CompanyContainer/CompanySlice';
import dashboardReducer from '../features/DashboardContainer/DashboardSlice';
import companyVotingReducer from '../features/CompanyVotingContainer/CompanyVotingSlice';
import titleReducer from '../features/General/TitleSlice';
import toolsReducer from '../features/ToolsContainer/ToolsSlice';
import toolsResolutionTrackerReducer from '../features/ToolsContainer/Voting/ToolsResolutionTrackerSlice';
import toolsDissidentVotingSummaryReducer from '../features/ToolsContainer/Voting/ToolsDissidentVotingSummarySlice';
import notifiedShortPositionDataReducer from '../features/ToolsContainer/ShortActivism/NotifiedShortPositionDataSlice';
import newsReducer from '../features/NewsContainer/NewsSlice';
import investorReducer from '../features/InvestorContainer/InvestorSlice';
import investorOwnershipReducer from '../features/InvestorContainer/Ownership/InvestorOwnershipSlice';
import votingByResolutionReducer from '../features/InvestorContainer/Voting/VotingByResolutionSlice';
import proxyContestVotingReducer from '../features/InvestorContainer/Voting/ProxyContestVotingSlice';
import investorFundVotesReducer from '../features/InvestorContainer/Voting/FundVotedSlice';
import faqHelpReducer from '../features/FAQHelpContainer/FAQHelpSlice';
import preferencesReducer from '../features/PreferencesContainer/PreferencesSlice';
import magazinesReportReducer from '../features/MagazinesReportContainer/MagazinesReportSlice';
import shortCampaignDataandAnalyticsReducer from '../features/ToolsContainer/ShortActivism/ShortCampaignDataandAnalyticsToolSlice';
import investorActivistShortReducer from '../features/InvestorContainer/ActivistShorts/ActivistShortSlice';
import AdvancedVotingDataSearchSlice from '../features/ToolsContainer/Voting/AdvancedVotingDataSearchSlice';
import votingProfileSlice from '../features/InvestorContainer/VotingProfile/InvestorVotingProfileSlice';
import myAlertSliceReducer from '../features/MyAlertContainer/MyAlert/MyAlertSlice';
import votingToolSliceReducer from '../features/ToolsContainer/Voting/VotingToolSlice';
import CompanyGovernanceDataAndAnalyticsTool from '../features/ToolsContainer/Governance/CompanyGovernanceAndAnalyticsToolsSlice';
import PeopleSearchReducer from '../features/PeopleSearchContainer/PeoplesearchSlice';
import AdvisersReducer from '../features/AdvisorContainer/AdvisersSlice';
import UniversalSearchReducer from '../features/UniversalSearchContainer/UniversalSearchSlice';
import HeaderReducer from '../features/LayoutContainer/HeaderSlice';
import activistCampaignsSliceReducer from '../features/CompanyContainer/Activism/ActivistCampaigns/ActivistCampaignsSlice';
import InboxAlertSlice from '../features/MyAlertContainer/MyAlert/InboxAlertSlice';
import AdvisorVotingNoActionReducer from '../features/AdvisorContainer/Voting/VotingNoActionSlice';
import GovernanceOverviewSliceReducer from '../features/CompanyContainer/Governance/GovernanceOverviewSlice';
import VotingOverviewReducer from '../features/InvestorContainer/Voting/VotingOverviewSlice';
import PowerSearchSlice from '../features/ToolsContainer/PowerSearch/PowerSearchSlice';
import ActivistCampaignAdvisor from '../features/ToolsContainer/ActivistCampaignAdvisorSlice';
import ShortsActivistCampaignAdvisor from '../features/ToolsContainer/ShortActivism/ShortActivistCampaignAdvisor_Slice';
import FillingSearchToolReducer from '../features/ToolsContainer/FillingSearchToolsSlice';
import PoisonPillDataAndAnalyticsReducer from '../features/ToolsContainer/Governance/PoisonPillDataAndAnalyticsSlice';
import InvestorActivismReducer from '../features/InvestorContainer/Activism/InvestorActivismSlice';
import DirectorDataAndAnalyticsToolsSlice from '../features/ToolsContainer/Governance/DirectorDataAndAnalyticsToolsSlice';
import ActivismTrendsSlice from '../features/ToolsContainer/ActivismTrendsSlice';
import AiSFillingsSearchSlice from '../features/ToolsContainer/ShortActivism/AiSFillingsSearchSlice';
import RecentDownloadsSlice from '../features/RecentDownloadsContainer/RecentDownloadsSlice';
import UpcomingEventsToolSlice from '../features/ToolsContainer/Governance/UpcomingEventsToolSlice';
import GovernanceScoreToolsSlice from '../features/ToolsContainer/Governance/GovernanceScoreToolsSlice';
import TrialSlice from '../features/CompanyContainer/TrialSlice';
import AmendmentDataandAnalyticsToolSlice from '../features/ToolsContainer/Governance/AmendmentDataandAnalyticsToolSlice';
import ActivistShortsOverviewSlice from '../features/CompanyContainer/ActivistShorts/ActivistShortsOverview/ActivistShortsOverviewSlice';
import ActivistShortCampaignSlice from '../features/CompanyContainer/ActivistShorts/ActivistShortCampaignsSlice';
import HistoricalGovernanceSlice from '../features/CompanyContainer/HistoricalGovernanceSlice';
import DirectorSkillsAndAnalyticsToolsSlice from '../features/ToolsContainer/Governance/DirectorSkillsAndAnalyticsToolsSlice';
import NotifiedHoldingsToolSlice from '../features/ToolsContainer/NotifiedHoldingsToolSlice';
import CorporateDefenseScoreDataToolSlice from '../features/ToolsContainer/Governance/CorporateDefenseScoreDataToolSlice';
import InvestorComparatorToolSlice from '../features/ToolsContainer/Voting/InvestorComparatorToolSlice';
import SaveSearchToolSlice from '../features/ToolsContainer/General/SaveSearchToolSlice';
import CompensationToolsSlice from '../features/ToolsContainer/Compensation/CompensationToolsSlice';
import PeopleCompensationSlice from '../features/PeopleSearchContainer/Compensation/CompensationSlice';
import PerformanceMetricBreakdownSlice from '../features/CompanyContainer/Compensation/PerformanceMetricBreakdownContainer/PerformanceMetricBreakdownSlice';
import PerformanceIndicatorsSlice from '../features/CompanyContainer/Compensation/PerformanceIndicatorsContainer/PerformanceIndicatorsSlice';
import ExecutiveCompensationSlice from '../features/CompanyContainer/Compensation/ExecutivePayContainer/ExecutiveCompensationSlice';
import CompensationPolicyDetailsSlice from '../features/CompanyContainer/Compensation/CompensationPolicyDetailsContainer/CompensationPolicyDetailsSlice';
import NonExecutivesFeePolicySlice from '../features/CompanyContainer/Compensation/NonExecutivesFeePolicyContainer/NonExecutivesFeePolicySlice';
import PayForPerformanceSlice from '../features/CompanyContainer/Compensation/PayForPerformanceContainer/PayForPerformanceSlice';
import OwnershipOverviewSlice from '../features/CompanyContainer/Ownership/OwnershipOverviewSlice';
import SayOnPayToolSlice from '../features/ToolsContainer/Compensation/SayOnPayVoteResultsSlice';
import ESGSlice from '../features/CompanyContainer/ESG/CompanyESGSlice';
import ESGScoreDataSlice from '../features/ToolsContainer/ESG/EsgScoreDataSlice';
import P4PIframeSlice from '../features/ToolsContainer/Compensation/P4PIframeSlice';
import settlementAgreementSlice from '../features/ToolsContainer/settlementAgreementSlice';
import { newsApi, newsApiOld } from '../features/v2/News/news-api';
import { votingApi } from '../features/v2/Voting/voting-api';
import { utilsApi } from '../features/v2/FeatureToggles/utils-api';
import { versionCheckApi } from '../features/v2/VersionCheck/version-check-api';
import SideBarSlice from '../features/LayoutContainer/SideBarSlice';
import ExecutiveSlice from '../features/CompanyContainer/GovernanceExecutive/ExecutiveSlice';
import RemunerationPolicySlice from '../features/CompanyContainer/Compensation/RemunerationPolicyContainer/RemunerationPolicySlice';

export default combineReducers({
  header: HeaderReducer,
  headerTitle: titleReducer,
  invFundVoted: investorFundVotesReducer,
  invVotingOverview: VotingOverviewReducer,
  investorVotingProfile: votingProfileSlice,
  magazinesReport: magazinesReportReducer,
  login: loginReducer,
  user: userReducer,
  pageSettings: pageSettingsReducer,
  company: companyReducer,
  dashboard: dashboardReducer,
  companyVoting: companyVotingReducer,
  tools: toolsReducer,
  toolsResolutionTracker: toolsResolutionTrackerReducer,
  toolsDissidentVotingSummary: toolsDissidentVotingSummaryReducer,
  news: newsReducer,
  investor: investorReducer,
  investorOwnership: investorOwnershipReducer,
  faqhelp: faqHelpReducer,
  preferences: preferencesReducer,
  votingByResolution: votingByResolutionReducer,
  proxyContestVoting: proxyContestVotingReducer,
  notifiedShortPositionData: notifiedShortPositionDataReducer,
  shortCampaignDataandAnalytics: shortCampaignDataandAnalyticsReducer,
  investorActivistShort: investorActivistShortReducer,
  advancedVotingDataSearch: AdvancedVotingDataSearchSlice,
  myAlert: myAlertSliceReducer,
  votingTool: votingToolSliceReducer,
  companyGovernance: CompanyGovernanceDataAndAnalyticsTool,
  Peoplesearch: PeopleSearchReducer,
  advisers: AdvisersReducer,
  universalsearch: UniversalSearchReducer,
  activistCampaigns: activistCampaignsSliceReducer,
  advisorVotingNoAction: AdvisorVotingNoActionReducer,
  inboxAlert: InboxAlertSlice,
  companyGovernanceOverview: GovernanceOverviewSliceReducer,
  powersearch: PowerSearchSlice,
  ActivistCampaignAdvisor,
  shortsActivistCampaignAdvisor: ShortsActivistCampaignAdvisor,
  fillingSearchTool: FillingSearchToolReducer,
  poisonpill: PoisonPillDataAndAnalyticsReducer,
  InvestorActivismSlice: InvestorActivismReducer,
  directoDataAndAnalytics: DirectorDataAndAnalyticsToolsSlice,
  activismtrends: ActivismTrendsSlice,
  aisfillingssearch: AiSFillingsSearchSlice,
  RecentDownloads: RecentDownloadsSlice,
  upcomingMeetings: UpcomingEventsToolSlice,
  governancescoretool: GovernanceScoreToolsSlice,
  trial: TrialSlice,
  amendmentDataandAnalyticsTool: AmendmentDataandAnalyticsToolSlice,
  companyActivistShortsOverview: ActivistShortsOverviewSlice,
  activistShortCampaigns: ActivistShortCampaignSlice,
  historicalGovernance: HistoricalGovernanceSlice,
  directoSkillsAndAnalytics: DirectorSkillsAndAnalyticsToolsSlice,
  notifiedHoldingsTool: NotifiedHoldingsToolSlice,
  corporateDefenseScoreDataTool: CorporateDefenseScoreDataToolSlice,
  investorComparatorTool: InvestorComparatorToolSlice,
  saveSearchFilter: SaveSearchToolSlice,
  CompensationTools: CompensationToolsSlice,
  peopleCompensation: PeopleCompensationSlice,
  companyPerformanceMetricBreakdown: PerformanceMetricBreakdownSlice,
  companyPerformanceIndicators: PerformanceIndicatorsSlice,
  executiveCompensation: ExecutiveCompensationSlice,
  companyCompensationPolicy: CompensationPolicyDetailsSlice,
  nonExecutivesFeePolicy: NonExecutivesFeePolicySlice,
  companyRemunerationPolicy: RemunerationPolicySlice,
  payForPerformance: PayForPerformanceSlice,
  ownershipOverview: OwnershipOverviewSlice,
  sayOnPayVoteTool: SayOnPayToolSlice,
  esgSlice: ESGSlice,
  esgscoredataSlice: ESGScoreDataSlice,
  P4PIframeSlice: P4PIframeSlice,
  settlementAggreement: settlementAgreementSlice,
  sideBar: SideBarSlice,
  companyExecutive: ExecutiveSlice,
  [newsApi.reducerPath]: newsApi.reducer,
  [newsApiOld.reducerPath]: newsApiOld.reducer,
  [votingApi.reducerPath]: votingApi.reducer,
  [utilsApi.reducerPath]: utilsApi.reducer,
  [versionCheckApi.reducerPath]: versionCheckApi.reducer,
  [newsApiOld.reducerPath]: newsApiOld.reducer,
});
